import { Fragment, useEffect, useState } from "react";
import {
  Box,
  Grid,
  List,
  Paper,
  ListItem,
  Typography,
  ListItemText,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { CancelOutlined, CheckCircle } from "@mui/icons-material";
import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";

import Error from "../Error/Error";
import { useAxios } from "../../hooks";
import { LoadingButton } from "../../components";
import SwitchToggle from "../../components/Switch";
import EventBookingSuccess from "../Success/EventBookingSuccess";
import pages from "../../constants/pages";
import { useSelector } from "react-redux";

const OuterBox = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  // min-height: 75vh;
  width: [100%, 100%, 100%, 800px];
  // margin: 10% 0;
  padding: 0px 25px;
  box-sizing: border-box;
  background: #ffffff;
`;

const OuterPaper = styled(Paper)`
  width: 100%;
  padding-top: 0px;
  border-radius: 5px;
  min-height: 20vh;
  background: rgba(255, 255, 255, 0.5);
  align-content: center;
  border-radius: 15px;
`;

function Consent() {
  const { visitorData } = useSelector((state) => state.memberDetails);
  const axiosDigipass = useAxios({
    baseURL: "digipass",
  });
  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  let hotelID = queryParams.get("hotel_id");
  let visitorId = queryParams.get("visitorId") || queryParams.get("visitor_id");
  let bookingID = queryParams.get("booking_id");
  let bookingREFID = queryParams.get("booking_ref_id");
  let entityID = queryParams.get("entity_id");
  let entityType = queryParams.get("entity_type");
  let userTypeId = queryParams.get("user_type_id");

  const localStorageData = { ...localStorage };

  const digipassDataKey = Object.keys(localStorageData).filter((item) => {
    return item.includes(visitorId || visitorData.ID);
  });

  const [open, setOpen] = useState(false);
  const [consent, setConsent] = useState({});
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(undefined);
  const [eventDetail, setEventDetail] = useState({});
  const [redirectURL, setRedirectURL] = useState("");
  const [openSuccess, setOpenSuccess] = useState(false);
  const [entityDetails, setEntityDetails] = useState({});
  const [displayMessage, setDisplayMessage] = useState("");
  const [checkFaceData, setCheckFaceData] = useState(false);
  const [checkContactDetails, setCheckContactDetails] = useState(false);

  function handleSubmit() {
    let data = [];

    if (checkFaceData) {
      if (!data.includes("face")) {
        data.push("face");
      }
    } else {
      const faceIndex = data.indexOf("face");
      if (faceIndex !== -1) {
        data.splice(faceIndex, 1);
      }
    }

    if (checkContactDetails) {
      if (!data.includes("contact-details")) {
        data.push("contact-details");
      }
    } else {
      const contactIndex = data.indexOf("contact-details");
      if (contactIndex !== -1) {
        data.splice(contactIndex, 1);
      }
    }

    let faceData = digipassDataKey.filter((item) => {
      return localStorage.getItem(item);
    });

    setLoading(true);
    axiosDigipass({
      url: "event/visitor/save-consent",
      method: "POST",
      data: {
        ...(visitorId && { visitor_id: visitorId }),
        ...((bookingID || bookingREFID) && {
          booking_id: bookingID || bookingREFID,
        }),
        ...((entityID || hotelID) && { entity_id: entityID || hotelID }),
        face_data: localStorageData[faceData[0]],
        user_type_id: userTypeId,
        consent_for: ["face", "contact-details"],
      },
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setOpenSuccess(response.status);
        setDisplayMessage(response.message.displayMessage);
        setStatus(response.status);
      } else {
        setOpen(!response.status);
        setDisplayMessage(response.displayMessage);
        setRedirectURL(response?.data?.redirect_url);
      }

      setLoading(false);
    });
  }

  useEffect(() => {
    if (entityID) {
      axiosDigipass({
        url: "/admin/business/entity_details?entity_id=" + entityID,
        disableRedirect: true,
        disableError: true,
      }).then((response) => {
        if (response.status) {
          setEntityDetails(response.data);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (entityType == "1") {
      axiosDigipass({
        url: "event/booking/event-details/" + bookingID,
        method: "GET",
        customAuthToken: "9beaa95b-c59f-4ec9-bb60-5f4ee1986311",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setEventDetail(response.data);
        } else {
          setOpen(!response.status);
          setDisplayMessage(response.displayMessage);
        }
      });
    }

    axiosDigipass({
      url:
        "admin/events/consent-details?entity_id=" +
        entityID +
        "&entity_type=" +
        (entityType || 4),
      method: "GET",
      disableRedirect: true,
      disableError: true,
    }).then((response) => {
      if (response.status) {
        setConsent(response.data);
      }
    });
  }, []);

  return (
    <Fragment>
      <Grid container flexDirection={"column"}>
        {entityType == "1" && (
          <Grid item container className="eventImageBox">
            <div
              style={{
                width: "100%",
                position: "relative",
                overflow: "hidden",
                boxShadow: "0px 2px 10px 3px #8e8e8e7d",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "35vh",
                }}
                src={eventDetail?.banner_image}
              />
            </div>
          </Grid>
        )}

        <Grid item padding={"20px 0px"}>
          <Grid item container justifyContent={"center"}>
            {entityID == "1" && (
              <Grid
                item
                className="companyBanner"
                xs={6}
                sx={{ boxShadow: "0px 2px 10px 3px #8e8e8e7d" }}
              >
                <img
                  width="100%"
                  height="100%"
                  style={{
                    borderRadius: "12.5px",
                  }}
                  src={eventDetail?.banner_image}
                ></img>
              </Grid>
            )}

            <Grid item md={12} sl={6} sx={{ alignContent: "center" }}>
              <OuterBox>
                <OuterPaper elevation={3}>
                  {status === undefined ? (
                    <Fragment>
                      <Typography
                        variant="h3"
                        fontWeight={900}
                        textAlign={"center"}
                        sx={{ "-webkit-text-stroke-width": ".5px" }}
                      >
                        Agreement to Consent Terms
                      </Typography>
                      <div>
                        <div>
                          <List>
                            <ListItem sx={{ padding: "10px" }}>
                              <ListItemText
                                primary={
                                  <Fragment>
                                    <Typography sx={{ fontSize: "14px" }}>
                                      {consent?.consent1 ||
                                        "To make your access smooth and contactless, we need your consent to use the following as your digital ID for verification"}
                                    </Typography>
                                  </Fragment>
                                }
                              />
                            </ListItem>

                            <ListItem sx={{ padding: "10px" }}>
                              <ListItemText
                                primary={
                                  <Fragment>
                                    <Typography sx={{ fontSize: "14px" }}>
                                      {consent?.consent2 ||
                                        "By proceeding, I acknowledge that the information I provide will be collected, stored, and processed for the purpose of delivering and improving this service. I understand that my data may be used to verify my identity, personalize my experience, and ensure the security of my account"}
                                    </Typography>
                                  </Fragment>
                                }
                              />
                            </ListItem>

                            <Typography
                              sx={{
                                fontSize: "16px",
                                fontWeight: "700",
                                color: "rgb(45 45 45 / 78%)",
                                margin: "10px 15px",
                                "-webkit-text-stroke-width": ".1px",
                              }}
                            >
                              Personally Identifiable Information (PII)
                            </Typography>

                            {[
                              {
                                label: "Name",
                                sub: "Full name as per records",
                              },
                              {
                                label: "Date of Birth (DOB)",
                                sub: "Date of birth",
                              },
                              { label: "Gender", sub: "Gender" },
                              {
                                label: "Last 4 Digits of Aadhar",
                                sub: "Last 4 digits of your identification",
                              },
                            ].map((item, index) => {
                              return (
                                <ListItem sx={{ padding: "2px" }}>
                                  <Grid item container>
                                    <Grid item xs={10}>
                                      <ListItemText
                                        primary={
                                          <Fragment>
                                            <Typography
                                              sx={{
                                                fontWeight: "700",
                                                color: "#000000c7",
                                              }}
                                            >
                                              {item.label}
                                            </Typography>
                                            <Typography
                                              sx={{
                                                fontWeight: "700",
                                                color: "#0000007d",
                                              }}
                                            >
                                              {item.sub}
                                            </Typography>
                                          </Fragment>
                                        }
                                      />
                                    </Grid>
                                    <Grid item xs={2}>
                                      <SwitchToggle />
                                    </Grid>
                                  </Grid>
                                </ListItem>
                              );
                            })}

                            <Typography
                              sx={{
                                fontSize: "16px",
                                fontWeight: "700",
                                color: "rgb(45 45 45 / 78%)",
                                margin: "10px 15px",
                                "-webkit-text-stroke-width": ".1px",
                              }}
                            >
                              Select Biometric Data
                            </Typography>

                            <ListItem sx={{ padding: "2px" }}>
                              <Grid item container>
                                <Grid item xs={10}>
                                  <ListItemText
                                    primary={
                                      <Fragment>
                                        <Typography
                                          sx={{
                                            fontWeight: "700",
                                            color: "#000000c7",
                                          }}
                                        >
                                          Facial Recognition
                                        </Typography>
                                        <Typography
                                          sx={{
                                            fontWeight: "700",
                                            color: "#0000007d",
                                          }}
                                        >
                                          Use facial recognition for
                                          authentication
                                        </Typography>
                                      </Fragment>
                                    }
                                  />
                                </Grid>

                                <Grid item xs={2}>
                                  <SwitchToggle />
                                </Grid>
                              </Grid>
                            </ListItem>
                          </List>
                        </div>
                      </div>

                      <LoadingButton
                        onClick={handleSubmit}
                        loading={loading}
                        size="small"
                      >
                        Submit
                      </LoadingButton>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Grid item container justifyContent={"center"} mb={5}>
                        {status ? (
                          <CheckCircle
                            sx={{ color: "green", fontSize: "45px" }}
                          />
                        ) : (
                          <CancelOutlined
                            sx={{ color: "red", fontSize: "45px" }}
                          />
                        )}
                      </Grid>

                      <Typography
                        variant="h3"
                        fontWeight={700}
                        textAlign={"center"}
                        sx={{ color: status ? "green" : "red" }}
                      >
                        {status ? "Submit Successfully" : "Failed"}
                      </Typography>
                    </Fragment>
                  )}

                  <Error
                    open={open}
                    setOpen={setOpen}
                    ErrorMessage={displayMessage}
                    handleOnClick={() => window.location.assign(redirectURL)}
                    buttonContent={redirectURL ? "Verify Again" : ""}
                  />
                </OuterPaper>
              </OuterBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <EventBookingSuccess
        eventName={entityDetails?.name}
        eventLocation={entityDetails?.address?.full_address}
        SuccessMessage={displayMessage}
        open={openSuccess}
        setOpen={setOpenSuccess}
        buttonContent="Okay"
        description="Your consent has been successfully saved"
        descriptionIcon={<FileDownloadDoneIcon />}
        handleOnClick={() => navigate(bookingREFID ? pages.home.route : -1)}
      />
    </Fragment>
  );
}

export default Consent;
